import { FormField, FormItem, FormLabel } from '@cobliteam/ui/form';
import AppCodeWrapper from './AppCodeWrapper';
import AppPopover from './AppPopover';

const DriverAppAccess = () => (
  <FormField name='driverCode'>
    {({ field }) => (
      <FormItem className='w-fit space-y-1'>
        <div className={'flex flex-col items-center'}>
          <div className={'flex items-center'}>
            <FormLabel>Acesso ao App</FormLabel>
            <AppPopover portal={false} />
          </div>
          <div className={'mt-1 flex min-w-[130px] items-center justify-center pr-5 uppercase'}>
            <AppCodeWrapper driverCode={field.value} />
          </div>
        </div>
      </FormItem>
    )}
  </FormField>
);

export default DriverAppAccess;
